.summary {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.top {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.lines {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.title {
  font-size: 22px;
}

.meta {
  font-size: 14px;
  color: var(--ink-2);
}

.chip {
  padding: 4px 12px;
  border: 1.5px solid var(--ink);
  border-radius: 999px;
  background: var(--surface);
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

/* The accent keeps its colour in both themes, so the text on it stays dark
 * rather than following --ink. */
.pending {
  background: var(--accent);
  color: var(--accent-ink);
}

.scores {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
}

.score {
  display: flex;
  flex-direction: column;
  min-width: 72px;
  padding: 8px 12px;
  border: 1.5px solid var(--ink);
  border-radius: var(--radius-control);
  background: var(--surface);
}

.scoreName {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--ink-3);
}

.scoreValue {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
}
